import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { TimeInputComponent } from 'components/time-input/time-input.component';

export interface TimeRange {
  from: string | null;
  to: string | null;
}

@Component({
  selector: 'app-time-range-picker',
  standalone: true,
  imports: [FormsModule, NgClass, TimeInputComponent],
  templateUrl: './time-range-picker.component.html',
  styleUrl: './time-range-picker.component.scss'
})
export class TimeRangePickerComponent implements OnChanges {
  @Input() from: string | null = null;
  @Input() to: string | null = null;
  @Input() disabled = false;
  @Input() noMargin = false;
  @Output() rangeChanged = new EventEmitter<TimeRange>();
  @Input() resetTrigger: boolean = false;

  onFromChange(event: string | null): void {
    this.from = event;
    this.emitChange();
  }

  onToChange(event: string | null): void {
    this.to = event;
    this.emitChange();
  }

  emitChange() {
    this.rangeChanged.emit({ from: this.from, to: this.to });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetTrigger'] && changes['resetTrigger'].currentValue === true) {
      this.resetTimeRange();
    }
  }

  resetTimeRange(): void {
    this.from = '';
    this.to = '';
    this.rangeChanged.emit({ from: '', to: '' });
  }
}
